import { useRef } from "react"

import { useAppDispatch } from "@/lib/storage/hooks"
import {
  resetUISettings,
  setUISettings,
  UiSettingsSliceState,
} from "@/lib/storage/ui-settings-slice"

interface LoadSettingsProps {
  initSettings: UiSettingsSliceState | null
}

export function LoadSettings({ initSettings }: LoadSettingsProps) {
  const dispatch = useAppDispatch()
  const init = useRef(false)

  // only load settings on full page load, after let the redux store handle it
  if (!init.current) {
    init.current = true
    if (initSettings) {
      dispatch(setUISettings(initSettings))
    } else {
      // If we don't have any pageProps initSettings (i.e. cookies is gone), we should reset the state of
      // Redux (UI settings: isSiteNavCollapsed).  Otherwise, there is mismpatch of the client and server
      // and cause Minified React error #418 or #423
      dispatch(resetUISettings())
    }
  }

  // maybe need to do a client side cookie check, if they can get out of sync somehow
  // useEffect(() => {
  //
  // }, [])

  return null
}
